import { useParams } from "react-router-dom";
import { StaffLawyerProfileForm } from "./StaffLawyerProfileForm";

export function LawyerProfileDetail() {
  const { id } = useParams<{ id: string }>();
  if (!id) return <p role="alert">Missing lawyer profile id.</p>;
  return <StaffLawyerProfileForm mode="edit" id={id} />;
}

export default LawyerProfileDetail;
